import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

// Продажи Ф6 (pek6): матрица видимости по ролям (ТЗ §3.3). Бэк режет ответы
// сам (закрытое не уезжает); эти хуки — второй слой: FE-гейты роутов и секций.

export type VisScope = 'none' | 'self' | 'all';
export type VisNumbers = 'full' | 'pct';

export interface VisibilityRow {
  role: string;
  block_key: string;
  scope: VisScope;
  numbers: VisNumbers;
}

export interface VisibilityBlockMeta {
  label: string;
  scopes: VisScope[];
  numbers: boolean;
}

export interface VisibilityMatrixPayload {
  managed_roles: string[];
  blocks: Record<string, VisibilityBlockMeta>;
  defaults: Record<string, Record<string, { scope: VisScope; numbers: VisNumbers }>>;
  rows: VisibilityRow[];
}

export interface MyVisibility {
  managed: boolean;
  full: boolean;
  role?: string;
  blocks?: Record<string, { scope: VisScope; numbers: VisNumbers }>;
}

const MATRIX_KEY = ['sales-visibility'];

export function useMyVisibility() {
  return useQuery({
    queryKey: ['sales-visibility-my'],
    queryFn: async () => {
      const { data } = await apiClient.get('/sales/visibility/my');
      return data.data as MyVisibility;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useVisibilityMatrix(enabled = true) {
  return useQuery({
    enabled,
    queryKey: MATRIX_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get('/sales/visibility');
      return data.data as VisibilityMatrixPayload;
    },
  });
}

export function useUpsertVisibility() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (rows: VisibilityRow[]) => {
      const { data } = await apiClient.put('/sales/visibility', { rows });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: MATRIX_KEY });
      qc.invalidateQueries({ queryKey: ['sales-visibility-my'] });
      // Выдача отчёта у managed-ролей меняется сразу — сбросить их кэш экрана.
      qc.invalidateQueries({ queryKey: ['sales-report'] });
      qc.invalidateQueries({ queryKey: ['sales-my-day'] });
    },
  });
}
